import { Component, Input } from '@angular/core';
import { FormControlComponent } from '@forms/form-control/form-control.component';

@Component({
  selector: 'rav-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent extends FormControlComponent {
  @Input() hasLabel = true;


  constructor() {
    super();
   }
}
